import { render, staticRenderFns } from "./DemoConfigPage.vue?vue&type=template&id=c0d63c9a"
import script from "./DemoConfigPage.vue?vue&type=script&lang=ts"
export * from "./DemoConfigPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports